<template>
<div class="c-step step-2">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Gdzie chcielibyście Państwo odebrać samochód?
      <br>
      <input type="text" v-model="answerInput.street" placeholder="Ulica">
      <br>
      <input type="text" v-model="answerInput.number" placeholder="Numer posesji">
      <br>
      <masked-input  mask="11-111" v-model="answerInput.zipcode" placeholder="Kod pocztowy" type="tel"/>
      <br>
      <input type="text" v-model="answerInput.city" placeholder="Miejscowość">
      <br>
    </div>
  </div>
  <div class="c-step-answers">
    <button v-if="enablenextStep" v-on:click="answer(answerInput)">Dalej</button>
  </div>
</div>
</template>

<script>
import stepsCounter from './../stepsCounter'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'step2',
  data() {
    return {
      answerInput: {
        street: '',
        number: '',
        zipcode: '',
        city: ''
      },
      enablenextStep: false
    }
  },
  components: {
    'stepsCounter': stepsCounter,
    MaskedInput
  },
  methods: {
    checkAnswers() {
      for (var key in this.answerInput) {
        if (this.answerInput[key] === '') {
          return false
        }
      }
      return true;
    },
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '2',
        answer: answer
      })
    },
    maskZipCode(){
        if(this.answerInput.zipcode.length == 2 && this.answerInput.zipcode.slice(-1) != '-'){
          this.answerInput.zipcode = this.answerInput.zipcode + '-';
        }
    }
  },
  watch: {
    answerInput: {
      handler: function() {
        this.enablenextStep = this.checkAnswers();
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
